define('ko/fn/mod',['knockout'], function(ko) {

    /**
     * Very simple method for enabling a chainable alternative to extend, which
     * is more suitable for non-static extensions. These are now arbitrarily
     * called "mods". You're fucking welcome!
     *
     * ```
     * subscribable.mod( myMod('some param') )
     *             .mod( myOtherMod() );
     * ```
     *
     * @param {Function} applyMod
     *
     * @return {this}
     */
    ko.subscribable.fn.mod = function(applyMod) {
        applyMod(this);
        return this;
    };

});

